import api from "@/services/api";

export default {
  state_list(params={}) {
    return api().get("state/list",{ params });
  },
  checkEligibility(params) {
    return api().post("check-eligibility", params);
  },
  getZipcodeCityCounty(params) {
    return api().post("zipcode-city-county", params);
  },
  race_list(params) {
    return api().post("race/list", params);
  },
  gender_list(params) {
    return api().post("gender-identity/list", params);
  },
  sex_with_list(params) {
    return api().post("sex-with/list", params);
  },
  sex_at_birth_list(params) {
    return api().post("sex-at-birth/list", params);
  },
  validateCode(params) {
    return api().post("validate-code", params);
  },
  validateProgramCode(params) {
    return api().post("validate-program-code", params);
  },
  stateAll() {
    return api().post("state/list-all");
  },
};
